/* eslint-disable import/unambiguous */
module.exports =
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_TARGET === 'web'
        ? require('./configureStore.debug')
        : require('./configureStore.main');
